// extracted by css-extract-rspack-plugin
export default {"cls1":"abandoned_cart_ping-cls1_uxT","cls2":"abandoned_cart_ping-cls2_vdK abandoned_cart_ping-cls1_uxT"};